module.exports = "https://coursera_assets.s3.amazonaws.com/images/7bf2a7be570c2742401e2b6f37239dcc.png";